import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

export const rotate = trigger('rotate', [
  state(
    'default',
    style({
      transform: 'rotate(0deg)',
    })
  ),
  state(
    'rotated',
    style({
      transform: 'rotate(180deg)',
    })
  ),
  transition('default => rotated', [animate('0.5s')]),
  transition('rotated => default', [animate('0.5s')]),
]);
